














































































































































































































































































import AMSformTable from '@/components/AMSformTable.vue';
import { Vue, Component, Watch } from 'vue-property-decorator';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSUpload from '@/components/AMSUpload.vue';
import { accountList, accountExport, accountMoneyList, accountRecharge } from '@/api/customer';
import AMSPagination, { PaginationModel } from '@/components/AMSPagination.vue';
import request from '../../utils/request';
import Utils from '../../utils/utils';
import Axios from 'axios';
import { AppStore } from '../../store/modules/app';
import AMSStaffSelector from '@/components/AMSStaffSelector.vue';
import colors from 'vuetify/es5/util/colors';
import { emptyRule, regRule, specialCharRule } from '../../utils/rules';
import AMSFixedTable from '@/views/finnancialManagement/AMSFixedTable.vue';
import { allStaff } from '@/api/staff';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSFloatTable from '@/views/finnancialManagement/AMSFloatTable.vue';
import moment from 'moment';
import utils from '@/utils/utils';
import { getModuleName } from '@/utils/utils';
interface Form {
  customerAccountId: string;
  customerId: string;
  amount: number;
  rechargeTime: string; //"2019-06-06T01:43:17.942Z",
  remark: string;
  pictureKey: string;
}

interface SearchForm {
  salesId: '';
  beautyAdvisor: '';
  customerFilter: '';
}

@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-dialog': AMSDialog,
    'ams-upload': AMSUpload,
    'ams-pagination': AMSPagination,
    'ams-staff-selector': AMSStaffSelector,
    'ams-fixed-table': AMSFixedTable,
    'ams-float-table': AMSFloatTable,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class CapitalAccount extends Vue {
  api: string = '/api/Customer/Account/List';
  form: SearchForm = {
    salesId: '',
    beautyAdvisor: '',
    customerFilter: ''
  };
  /**销售 美导 */
  activeItems: any[] = [{ value: '', text: '全部' }];
  /**当前时间 */
  currentTime: string = new Date().toISOString().substr(0, 10);
  menu: boolean = false;
  showDialog: boolean = false;
  showConfirmDialog: boolean = false;
  requestLoading: boolean = false;
  /**面包屑 */
  breadItems = [
    {
      text: '财务管理',
      disabled: false,
      href: 'capitalAccount'
    },
    {
      text: '资金账户',
      disabled: true
    }
  ];
  /**充值账户 */
  items: any[] = [];
  /**列表数据 */
  datas: any[] = [];
  /**表头 */
  headers: any[] = [];
  /**余额总计 */
  totalBalance: string = '0';
  /**冻结金额总计 */
  totalFreezeAmount: string = '0';
  /**当前选中的用户 */
  selectedAccount: any = null;
  /**分页 */
  paging: PaginationModel = {
    descending: false,
    page: 0,
    rowsPerPage: 10, // -1 for All",
    totalItems: 0,
    pageSizes: [10, 20, 30, 40],
    sortBy: ''
  };
  sortStr: string = ''; //ee09b0ed-a554-4f70-9076-47e9fdfb57bb|Balance desc
  customerFilter: string = '';
  /**当前排序的头部 */
  currentSortHead: any = {};
  /**选中的销售员 */
  sale: any = ''; //null;
  /**选中的美导 */
  guider: any = ''; //null;
  /**附件 */
  attachment: any[] = [];
  /**选中的充值账户 */
  account: any = null;
  /**充值金额 */
  rechargeAmount: string = '';
  /**充值时间 */
  date: string = new Date().toISOString().substr(0, 10);
  /**备注 */
  remark: string = '';
  /**上传的图片数量限制 必须每次都重置 */
  uploadLimit: number = 1;
  startVal: number = 0;

  // 充值类型
  rechargeType: string = 'Recharge';

  /**点击了清空按钮 */
  onClear() {
    this.customerFilter = '';
    this.sale = '';
    this.guider = '';
    // (this.$refs.saleSelector as any).reset();
    // (this.$refs.guiderSelector as any).reset();
  }

  /**充值账户规则 */
  get rechargeAccountRules() {
    if (this.account) {
      return [];
    } else {
      return [emptyRule('充值账户')];
    }
  }
  formatPrice(num: number) {
    return utils.formatCurrencyPrice(num);
  }

  /**充值金额规则 */
  get rechargeAmountRules() {
    if (this.rechargeAmount != '') {
      const m = parseFloat(this.rechargeAmount);
      if (isNaN(m)) {
        const rule = (value: any) => {
          //特殊字符
          if (/[^\u4e00-\u9fa5a-zA-Z0-9\w]/g.test(value)) {
            return '请输入正确的充值金额';
          } else {
            const v = value.match(/^\d*(\.?\d{0,2})/g);
            if (v != null && v.length == 1 && v[0] == '') {
              return '请输入正确的充值金额';
            } else {
              return true;
            }
          }
        };
        return [rule];
      } else {
        // if (m <= 0) {
        //   return ['请输入大于零的充值金额'];
        // } else {
        let i = this.rechargeAmount.indexOf('.');
        if (i != -1) {
          let strs = this.rechargeAmount.split('.');
          if (strs.length >= 2) {
            //判断小数点 左右两边是否是数字
            let left = strs[0];
            let right = strs[1];
            if (left == '' || right == '') {
              return ['请输入正确的充值金额'];
            } else {
              return [];
            }
          } else {
            return [];
          }
        } else {
          return [];
        }
        // }
      }
      return [];
    } else {
      return [emptyRule('充值金额')];
    }
  }

  /**充值显示名称 */
  get accountName() {
    return this.account ? this.account.name : '';
  }

  initForm() {
    this.form = {
      salesId: '',
      beautyAdvisor: '',
      customerFilter: ''
    };
  }

  /**获取销售 美导*/
  getStaff() {
    allStaff({ isActive: true, permissionCheck: true }).then((data: any) => {
      this.activeItems = [{ value: '', text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }

  /**点击弹框的取消 */
  closeAMSDialog(type: any) {
    if (type == 'confirm') {
      this.showConfirmDialog = false;
    } else {
      (this.$refs.rechargeForm as any).resetValidation();
      this.resetForm();
      this.showDialog = false;
      (this.$refs.imgupload as any).resetLimit();
    }
  }

  resetForm() {
    this.date = new Date().toISOString().substr(0, 10);
    this.rechargeAmount = '';
    this.remark = '';
    this.attachment = [];
    this.rechargeType = 'Recharge';
    this.account = null;
  }

  /**点击弹框的确定 */
  submitAMSDialog(stop: Function, type: any) {
    if (type == 'confirm') {
      if (this.account && this.selectedAccount && this.rechargeAmount != '') {
        let dateEdit = this.date == this.currentTime ? moment.utc() : moment(this.date).utc();
        const params = {
          customerAccountId: this.account.id,
          customerId: this.selectedAccount.id, //this.selectedAccount.origin.id,
          amount: this.rechargeAmount,
          rechargeTime: dateEdit,
          remark: this.remark,
          pictureKey: this.attachment.length > 0 ? this.attachment[0].pictureKey : '',
          rechargeType: this.rechargeType
        };
        this.requestLoading = true;
        const _this = this;
        accountRecharge(params)
          .then(response => {
            AppStore.ShowSuccess('操作成功');
            this.requestLoading = false;
            this.showConfirmDialog = false;
            this.showDialog = false;
            _this.paging.page = 0;
            this.getList();
            _this.resetForm();
            (this.$refs.imgupload as any).resetLimit();
          })
          .finally(() => {
            stop();
            this.requestLoading = false;
          })
          .catch(error => {
            stop();
            AppStore.ShowError(error.response.data && error.response.data.error && error.response.data.error.message ? error.response.data.error.message : '充值失败');
            this.showConfirmDialog = false;
            this.requestLoading = false;
            this.showDialog = false;
            _this.resetForm();
            (this.$refs.imgupload as any).resetLimit();
          });
      } else {
        AppStore.ShowError('数据有误');
      }
    } else {
      if ((this.$refs.rechargeForm as any).validate()) {
        this.showConfirmDialog = true;
      } else {
        stop();
      }
    }
  }
  created() {
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
    }
  }
  mounted() {
    this.getList();
    this.getStaff();
  }

  /**获取数据列表 */
  getList(formData?: any) {
    const _this = this;
    var params = {
      SkipCount: _this.paging.page * _this.paging.rowsPerPage, //当前页
      MaxResultCount: _this.paging.rowsPerPage, //每页大小
      Sorting: _this.sortStr
    };
    if (formData) {
      params = {
        ...params,
        ...formData
      };
    }

    accountList(params)
      .then((response: any) => {
        _this.paging.totalItems = response.data.totalCount;
        // _this.totalFreezeAmount = response.totalFreezeAmount;
        _this.totalFreezeAmount = Utils.formatCurrencyPrice(response.totalFreezeAmount);
        _this.totalBalance = Utils.formatCurrencyPrice(response.totalBalance);
        // _this.totalBalance = response.totalBalance;

        this.headers = [];
        this.datas = [];
        response.headers.forEach((header: any, i: any) => {
          this.headers.push({
            text: header.text,
            value: header.fieldName,
            sortable: header.isSort,
            isCurrency: i === 2 || i === 3 || i === 4 || i === 5 || i === 6 || i === 7 || i === 8,
            align: i !== 0 && i !== 1 ? 'right' : 'left'
          });
        });
        this.headers.push({
          text: '操作',
          align: 'center',
          width: 250,
          isDetail: [
            {
              callBack: (btn: any, row: any, key: string) => {
                this.onRechargeClick(row.item);
              },
              text: '充值',
              color: '#1ABC9C',
              isShowBtn: (row: any) => {
                return Utils.isPermission('FinanceManager.FinanceAccount.RechargeOrEdit');
              }
            },
            {
              callBack: (btn: any, row: any, key: string) => {
                this.onRechargePassClick(row.item);
              },
              text: '审核',
              color: '#1ABC9C',
              isShowBtn: (row: any) => {
                return Utils.isPermission('FinanceManager.RechargeList.Review');
              }
            },
            {
              callBack: (btn: any, row: any, key: string) => {
                this.onDetailClick(row.item);
              },
              text: '查看明细',
              color: '#1ABC9C',
              isShowBtn: (row: any) => {
                return Utils.isPermission('FinanceManager.IncomeAndExpenditureDetails');
              }
            }
          ]
        });
        // let items: any[] = [];
        // this.datas = response.data.items.forEach((item: any) => {
        //   var newObject: { [key: string]: any } = {};
        //   this.headers.forEach((header, idx) => {
        //     newObject[header.value] = item.data[idx];
        //   });
        //   newObject['id'] = item.id;
        //   newObject['isActive'] = item.isActive;
        //   items.push(newObject);
        // });
        // this.datas = items;
        // console.log(this.datas, '数据');

        // const heads: any[] = response.headers;
        // var generateHeads: any[] = [];
        // heads.map(v => {
        //   const key = `${v.fieldName}*${v.categoryId}`;
        //   const item = {
        //     align: 'right',
        //     title: v.name,
        //     width: '200',
        //     key: key,
        //     sortable: true,
        //     sortter: this.onSort,
        //     sortType: key == _this.currentSortHead.key ? _this.currentSortHead.sortType : undefined,
        //     categoryId: v.categoryId
        //   };
        //   generateHeads.push(item);
        // });
        // this.headers = [
        //   {
        //     title: '客户名称',
        //     fixed: 'left',
        //     key: 'name',
        //     width: '150',
        //     align: 'left'
        //   },
        //   {
        //     title: '手机号',
        //     fixed: 'left',
        //     key: 'phone',
        //     width: '130',
        //     align: 'left'
        //   },
        //   ...generateHeads,
        //   {
        //     title: '累计充值金额',
        //     fixed: 'right',
        //     width: '140',
        //     key: 'totalRechargeAmount',
        //     align: 'right'
        //   },
        //   {
        //     title: '累计订货金额',
        //     fixed: 'right',
        //     width: '140',
        //     key: 'totalOrderAmount',
        //     align: 'right'
        //   },
        //   {
        //     title: '总余额',
        //     fixed: 'right',
        //     width: '140',
        //     key: 'totalAmount',
        //     sortKey: 'totalBalance',
        //     sortable: true,
        //     sortter: this.onSort,
        //     sortType: 'totalBalance' == _this.currentSortHead.sortKey ? _this.currentSortHead.sortType : undefined,
        //     align: 'right'
        //   },
        //   {
        //     title: '操作',
        //     fixed: 'right',
        //     width: '200',
        //     key: 'action',
        //     render: [
        //       Utils.isPermission('FinanceManager.FinanceAccount.RechargeOrEdit')
        //         ? {
        //             title: '充值',
        //             icon: 'edit',
        //             color: 'primary',
        //             click: this.onRechargeClick
        //           }
        //         : {},

        //       Utils.isPermission('FinanceManager.RechargeList.Review')
        //         ? {
        //             title: '审核',
        //             icon: 'delete',
        //             color: 'primary',
        //             click: this.onRechargePassClick
        //           }
        //         : {},
        //       Utils.isPermission('FinanceManager.IncomeAndExpenditureDetails')
        //         ? {
        //             title: '查看明细',
        //             icon: 'delete',
        //             color: 'primary',
        //             click: this.onDetailClick
        //           }
        //         : {}
        //     ]
        //   }
        // ];

        // const items: any[] = response.data.items;
        // var generateItems: any[] = [];
        // items.map(v => {
        //   var item: { [key: string]: any } = {
        //     name: v.name,
        //     phone: v.phone,
        //     totalAmount: Utils.formatCurrencyPrice(v.totalAmount),
        //     totalRechargeAmount: Utils.formatCurrencyPrice(v.totalRechargeAmount),
        //     totalOrderAmount: Utils.formatCurrencyPrice(v.totalOrderAmount),
        //     origin: v
        //   };
        //   const fields: any[] = v.fields;
        //   if (fields) {
        //     fields.map(f => {
        //       const key = `${f.fieldName}*${f.categoryId}`;
        //       const value = f.value;
        //       if (key) {
        //         item[key] = isNaN(parseFloat(value)) ? value : Utils.formatCurrencyPrice(value);
        //       }
        //     });
        //   }
        //   generateItems.push(item);
        // });

        // this.datas = generateItems;
      })
      .catch(error => {});
  }

  onPageChange(page: number) {
    this.paging.page = page;
    this.getList(this.getParams());
  }

  onPageSizeChange(size: number) {
    this.paging.rowsPerPage = size;
    this.getList(this.getParams());
  }

  /**点击了充值 */
  onRechargeClick(item: any) {
    if (item.isActive && item.isActive == true) {
      this.selectedAccount = item;
      this.selectedAccount.name = item['Customer.Name'];
      this.showDialog = true;
    } else {
      AppStore.ShowError('该用户已被禁用，无法充值');
    }
  }

  /**点击了明细 */
  onDetailClick(item: any) {
    this.selectedAccount = item;
    if (this.selectedAccount) {
      this.selectedAccount.name = item['Customer.Name'];
      this.$router.push({
        name: `incomeExpenditureDetail`,
        query: {
          id: this.selectedAccount.id,
          item: this.selectedAccount
        }
      });
    }
  }

  /* 点击了审核 */
  onRechargePassClick(item: any) {
    this.selectedAccount = item;
    this.selectedAccount.name = item['Customer.Name'];
    if (this.selectedAccount) {
      this.$router.push({
        name: `rechargeList`,
        query: {
          id: this.selectedAccount.id,
          item: this.selectedAccount
        }
      });
    }
  }

  /**点击搜索 */
  onSearch() {
    debugger;
    this.paging.page = 0;
    this.getList(this.getParams());
  }

  getParams() {
    let params: { [key: string]: any } = {
      customerFilter: this.customerFilter
    };
    if (this.sale) {
      params['salesId'] = this.sale; //this.sale.id;
    }
    if (this.guider) {
      params['beautyAdvisor'] = this.guider; //this.guider.id;
    }
    return params;
  }

  /**点击导出 */
  onExport() {
    let params: { [key: string]: any } = {
      customerFilter: this.customerFilter
    };
    if (this.sale) {
      params['SalesId'] = this.sale.id ? this.sale.id : this.sale;
    }
    if (this.guider) {
      params['BeautyAdvisor'] = this.guider.id ? this.guider.id : this.guider;
    }
    accountExport(params)
      .then(response => {
        AppStore.ShowSuccess('下载成功');
      })
      .catch(error => {
        AppStore.ShowError('下载失败');
      });
  }

  onSort(item: any) {
    if (item.sortKey) {
      switch (item.sortType) {
        case null:
        case '':
        case undefined:
          this.sortStr = '';
          break;
        case 'asc':
          this.sortStr = `${item.sortKey} asc`;
          break;
        case 'desc':
          this.sortStr = `${item.sortKey} desc`;
          break;
        default:
          break;
      }
    } else {
      let type = (item.key as string).split('*');
      switch (item.sortType) {
        case null:
        case '':
        case undefined:
          this.sortStr = '';
          break;
        case 'asc':
          this.sortStr = `${item.categoryId}|${type.length > 0 ? type[0] : ''} asc`;
          break;
        case 'desc':
          this.sortStr = `${item.categoryId}|${type.length > 0 ? type[0] : ''} desc`;
          break;
        default:
          break;
      }
    }

    this.currentSortHead = item;
    this.onSearch();
  }

  /**选中了某个充值账户 */
  onAccountClick(v: any, i: any) {
    this.account = v;
  }

  /**获取充值账户 */
  getAccount() {
    if (this.selectedAccount) {
      accountMoneyList(this.selectedAccount.id)
        .then((response: any) => {
          this.items = response.items;
        })
        .catch(error => {
          AppStore.ShowError('获取充值账户失败');
        });
    }
    // if (this.selectedAccount && this.selectedAccount.origin) {
    //   accountMoneyList(this.selectedAccount.origin.id)
    //     .then((response: any) => {
    //       this.items = response.items;
    //     })
    //     .catch(error => {
    //       AppStore.ShowError('获取充值账户失败');
    //     });
    // }
  }

  @Watch('showDialog', { immediate: true, deep: true })
  onMenuChange(value: boolean, oldValue: any) {
    if (value == true) {
      this.items = [];
      this.getAccount();
    }
  }

  /**充值金额输入事件 */
  onRechargeAmountInput(value: string) {
    // let v = value.match(/^\d*(\.?\d{0,2})/g);
    let v = value.match(/^\-?\d*(\.?\d{0,2})/g);
    if (v != null && v.length == 1 && v[0] == '') {
      //不能输入空格
      if (value.length > 0 && value.trim().length == 0) {
        this.$nextTick(() => {
          this.rechargeAmount = '';
        });
      }
    } else {
      if (v != null && v.length > 0) {
        let s = v[0];
        this.$nextTick(() => {
          // if (parseFloat(s) <= 0) {
          //   this.rechargeAmount = s;
          // } else {
          let i = s.indexOf('.');
          if (i != -1) {
            let strs = s.split('.');
            let last = strs[strs.length - 1];
            if (last.length > 2) {
              this.rechargeAmount = parseFloat(s).toFixed(2);
            } else {
              this.rechargeAmount = s; //parseFloat(s).toFixed(2)
            }
          } else {
            if (s.length > 9) {
              //整数长度超过9位
              this.rechargeAmount = s.substr(0, 9);
            } else {
              //整数长度没有超过9位
              if (s.indexOf('.') == -1) {
                this.rechargeAmount = s;
              }
            }
            // }
          }
        });
      } else {
        console.log('格式有问题');
      }
    }
  }

  onSaleClear() {
    setTimeout(() => {
      this.form.salesId = '';
    }, 1);
  }

  onGuiderClear() {
    setTimeout(() => {
      this.form.beautyAdvisor = '';
    }, 1);
  }

  handleGetOtherData(obj: any) {
    this.totalFreezeAmount = Utils.formatCurrencyPrice(obj.totalFreezeAmount);
    this.totalBalance = Utils.formatCurrencyPrice(obj.totalBalance);
  }

  onChargeTypeChange(value: any) {}
}
